module.exports = __webpack_public_path__ + "static/media/woocommerce-seo-for-higher-revenue.66eecd70.png";